import { createSlice } from '@reduxjs/toolkit';
import { OrderItemUpdateState } from './api/interface';
import { updateOrderItem, updateOrderItemDirect } from './api';

const initialState: OrderItemUpdateState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
  successMessage: '',
};

const orderItemSlice = createSlice({
  name: 'orderItem',
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
      state.successMessage = '';
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = '';
    },
    clearSuccess: (state) => {
      state.isSuccess = false;
      state.successMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // Update Order Item
      .addCase(updateOrderItem.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = '';
        state.successMessage = '';
      })
      .addCase(updateOrderItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.successMessage = action.payload.message;
        state.errorMessage = '';
      })
      .addCase(updateOrderItem.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload as string;
        state.successMessage = '';
      })
      // Update Order Item Direct
      .addCase(updateOrderItemDirect.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = '';
        state.successMessage = '';
      })
      .addCase(updateOrderItemDirect.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.successMessage = action.payload.message;
        state.errorMessage = '';
      })
      .addCase(updateOrderItemDirect.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload as string;
        state.successMessage = '';
      });
  },
});

export const { resetState, clearError, clearSuccess } = orderItemSlice.actions;
export default orderItemSlice.reducer;
